/*globals $*/

/**
 * Convert degrees to radians, more sientific way to represent degrees.
 * @param {number} num degrees to convert to radians
 * @return {number} radians
 */
function toRad(num) {
  return num * Math.PI / 180;
}

/**
 * Calculate distance approximation between place A and B in kilometers. Takes account Earth curviture?
 *
 * @param {number} lat1 latitude of place A in WGS84 coordinates
 * @param {number} lon1 lognitude of place A in WGS84 coordinates
 * @param {number} lat2 latitude of place B in WGS84 coordinates
 * @param {number} lon2 latitude of place B in WGS84 coordinates
 * @return {number} distance in kilometers.
 */
function calculateDistance(lat1, lon1, lat2, lon2) {
  var R = 6378137; // km
  var dLat = toRad(lat2 - lat1);
  var dLon = toRad(lon2 - lon1);
  lat1 = toRad(lat1);
  lat2 = toRad(lat2);

  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; //calculate distance between lat/lon

  return (d / 1000).toFixed(1);
}

export default {
  calculateDistance,
  toRad
}

export {
  calculateDistance,
  toRad
}
